// All Vitality Integrative Health content sourced from client documents & flyers.

export const CONTACT = {
  email: "chasity@vitalityintegrativehealth.org",
  phone: "208-406-8858",
  phoneHref: "tel:2084068858",
  location: "Pocatello, ID",
  nearby: ["Blackfoot", "Idaho Falls", "Ammon", "Fort Hall", "and more"],
};

export const IV_THERAPIES = [
  {
    n: 1,
    name: "Hydration Recovery IV",
    price: "$99",
    items: ["1L Hydration", "B-Complex", "Vitamin B12"],
    tagline: "Rehydrate. Restore. Rejuvenate.",
  },
  {
    n: 2,
    name: "Immunity Defense IV",
    price: "$169",
    items: ["Vitamin C 10g", "Zinc", "Magnesium", "B-Complex", "Vitamin B12"],
    tagline: "Strengthen Immunity. Protect. Thrive.",
  },
  {
    n: 3,
    name: "Myers' Wellness Cocktail",
    price: "$149",
    items: ["Vitamin C 5g", "Magnesium 1g", "Calcium Gluconate", "B-Complex", "Vitamin B12"],
    tagline: "Energy. Wellness. Balance.",
  },
  {
    n: 4,
    name: "Energy & Performance IV",
    price: "$169",
    items: ["L-Carnitine", "Vitamin C 5g", "B-Complex", "Vitamin B12", "Magnesium"],
    tagline: "Fuel Your Energy. Elevate Performance.",
  },
  {
    n: 5,
    name: "Beauty & Glow IV",
    price: "$169",
    items: ["Glutathione 1,200mg", "Vitamin C 5g", "Biotin", "B-Complex"],
    tagline: "Radiate Beauty. Glow from Within.",
  },
  {
    n: 6,
    name: "Recovery & Wellness IV",
    price: "$189",
    items: ["Vitamin C 10g", "Zinc", "Magnesium", "Glutathione 1,200mg", "Vitamin B12"],
    tagline: "Recover. Restore. Optimize Wellness.",
  },
  {
    n: 7,
    name: "Anti-Aging & Longevity IV",
    price: "$169",
    items: ["NAD+ Booster", "Glutathione", "Vitamin C", "B-Complex", "Magnesium"],
    tagline: "Support Cellular Health. Age Beautifully.",
  },
  {
    n: 8,
    name: "Brain & Focus IV",
    price: "$169",
    items: ["B-Complex", "Magnesium", "L-Carnitine", "Alpha Lipoic Acid", "Vitamin B12"],
    tagline: "Sharpen Focus. Enhance Clarity.",
  },
];

export const ADD_ONS = [
  { name: "Vitamin B12", dose: "1,000 mcg", price: "$20" },
  { name: "Vitamin C", dose: "2.5g", price: "$25" },
  { name: "Vitamin C", dose: "5g", price: "$40" },
  { name: "Glutathione", dose: "600mg", price: "$40" },
  { name: "Glutathione", dose: "1,200mg", price: "$65" },
  { name: "Biotin", dose: "5mg", price: "$20" },
  { name: "Zinc", dose: "5mg", price: "$15" },
  { name: "Magnesium", dose: "500mg", price: "$15" },
  { name: "L-Carnitine", dose: "500mg", price: "$30" },
  { name: "Ondansetron", dose: "4mg *", price: "$20" },
  { name: "Famotidine", dose: "20mg *", price: "$20" },
];

export const SIGNATURE_INFUSIONS = [
  { name: "Vitality Original Infusion", desc: "Foundational hydration and wellness support." },
  { name: "Hydration & Recovery", desc: "Supports recovery, hydration, and electrolyte replenishment." },
  { name: "Vita Complex", desc: "Comprehensive vitamin and nutrient replenishment." },
  { name: "Mineral Replacement", desc: "Supports hydration, cellular function, and nutrient balance." },
  { name: "Skin & Hair Infusion", desc: "Promotes healthy skin, hair, and nail growth." },
  { name: "Tres Aminos", desc: "Supports muscle recovery, metabolism, and performance." },
  { name: "Amino Infusion", desc: "Amino acid support for recovery and wellness." },
  { name: "Debloat Infusion", desc: "Supports digestive wellness and reduces bloating." },
  { name: "Circulate Infusion", desc: "Supports circulation, cardiovascular wellness, and vitality." },
];

export const PERFECT_FOR = [
  "Busy Professionals",
  "Athletes & Active Individuals",
  "Immune Support",
  "Travel & Jet Lag Recovery",
  "Dehydration",
  "Beauty & Skin Health",
  "Energy & Performance",
  "Detox & Recovery",
];

export const GLP1 = {
  tirzepatide: {
    name: "Tirzepatide Microdose Program",
    membership: "$155",
    tiers: [
      { label: "Starting Dose", price: "$155" },
      { label: "If dosage increases", price: "$185" },
      { label: "High Dose (15 mg)", price: "$239" },
    ],
  },
  semaglutide: {
    name: "Semaglutide Microdose Program",
    membership: "$129",
    tiers: [
      { label: "Starter Microdose Program", price: "$129" },
      { label: "Wellness Dose Program", price: "$149" },
      { label: "Enhanced Dose Program", price: "$179" },
    ],
  },
  includes: [
    "Ongoing education and support",
    "Provider review and oversight",
    "Nursing & provider visits available outside of membership",
  ],
  consults: [
    { label: "Nursing Visit", price: "$40", desc: "Additional support, education, symptom check-ins, and progress reviews." },
    { label: "Provider Visit", price: "$60", desc: "In-depth evaluation, medication management, and personalized plan optimization." },
  ],
};

export const BOTOX_AREAS = ["Forehead Lines", "Frown Lines (11s)", "Crow's Feet", "Brow Lift", "Lip Flip", "Chin Dimpling"];
export const FILLER_AREAS = ["Lips", "Cheeks", "Nasolabial Folds", "Marionette Lines", "Jawline", "Under Eyes (Tear Troughs)"];

export const OTHER_SERVICES = [
  { name: "Primary Care", desc: "Comprehensive, preventative care for individuals and families across the lifespan." },
  { name: "Hormone Health & Optimization", desc: "Personalized hormone evaluations to support energy, mood, and well-being." },
  { name: "Peptide Therapy", desc: "Advanced therapies supporting recovery, metabolism, and healthy aging." },
  { name: "Concierge Medical Services", desc: "Healthcare designed around your schedule — at home, in office, or on the go." },
  { name: "Telehealth Services", desc: "Convenient virtual appointments and ongoing provider support from home." },
  { name: "Wellness Coaching", desc: "Sustainable habits for nutrition, movement, sleep, and stress management." },
];

export const WHY_CHOOSE = [
  "Personalized, whole-person care",
  "Medical expertise you can trust",
  "High-quality products & safe techniques",
  "Results that look and feel natural",
  "A partner in your wellness & beauty journey",
];

export const MEMBERSHIP_TIERS = [
  {
    name: "Vitality Essential",
    sub: "Wellness Membership",
    price: "$119",
    accent: "#1A2B4C",
    includes: [
      "1 Vitality Original IV Infusion per month",
      "10% off additional IV infusions",
      "Priority scheduling",
      "Birthday month discount",
    ],
    tagline: "A simple start to feeling your best.",
  },
  {
    name: "Vitality Thrive",
    sub: "Membership",
    price: "$159",
    accent: "#5E4B8B",
    popular: true,
    includes: [
      "One Vitality Original IV Infusion monthly ($110 value)",
      "One vitamin injection monthly ($25–$40 value)",
      "Priority scheduling",
      "Birthday month bonus infusion add-on",
    ],
    tagline: "Thrive every month. Glow every day.",
  },
  {
    name: "Vitality Premium",
    sub: "Wellness Membership",
    price: "$219",
    accent: "#3F5B45",
    includes: [
      "2 IV infusions per month",
      "15% off additional infusions",
      "10% off injections and add-ons",
      "Priority scheduling",
      "Family member discount",
      "Birthday month bonus infusion add-on",
    ],
    tagline: "More wellness. More savings. More you.",
  },
  {
    name: "Elite Vitality",
    sub: "Membership",
    price: "$399",
    accent: "#142139",
    includes: [
      "4 IV infusions per month",
      "20% off additional services",
      "One complimentary vitamin injection monthly",
      "Priority same-week appointments",
      "Concierge wellness support",
    ],
    tagline: "The ultimate in wellness & care.",
  },
];

export const MEMBERSHIP_PERKS = [
  {
    title: "Punch Card Program",
    icon: "card",
    items: [
      "Buy 5 infusions → receive 6th infusion FREE",
      "Buy 10 infusions → receive 11th infusion FREE",
      "Great for athletes, travelers & chronic wellness clients",
    ],
  },
  {
    title: "VIP Birthday Perks",
    icon: "star",
    items: [
      "$20 infusion credit during your birthday month, or",
      "Complimentary vitamin booster with any infusion",
    ],
  },
  {
    title: "Referral Program",
    icon: "users",
    items: [
      "Refer a friend → you both receive $20 off",
      "Refer 5 friends → complimentary Vitality Original IV",
    ],
  },
  {
    title: "Anniversary Rewards",
    icon: "award",
    items: [
      "Celebrate one year of membership",
      "Free vitamin injection or infusion add-on",
    ],
  },
];

export const MEMBERSHIP_PACKAGES = [
  {
    title: "Hydration Package",
    icon: "droplet",
    items: ["3 infusions prepaid = 10% savings", "6 infusions prepaid = 15% savings"],
  },
  {
    title: "Athletic Recovery Package",
    icon: "dumbbell",
    items: ["Monthly recovery infusion package", "Includes amino acids & performance boosters", "Exclusive member pricing"],
  },
  {
    title: "Beauty & Glow Package",
    icon: "sparkles",
    items: ["Monthly Skin & Hair infusion", "Discounted aesthetics services", "Complimentary wellness consultation every 6 months"],
  },
];
